module.exports = __webpack_public_path__ + "static/img/page66.da76a31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page66.jpg
// module id = pIQR
// module chunks = 0